import React from 'react'
import {ApiRequest} from '../../../../../../services/api/api'
import {SuborderCommonModal} from './suborder-common-modal/suborder-common-modal'

/**
 * SuborderTakeModal
 * A modal that allows a user to take a suborder.
 *
 * @prop {boolean} visible Whether the modal is visible or not.
 * @prop {function} onOk Callback when the modal is confirmed.
 * @prop {function} onCancel Callback when the modal is cancelled.
 * @prop {object} data The suborder data.
 * @prop {object} machine The machine data.
 * @prop {boolean} [isPackaging=false] Whether the modal is for packaging or not.
 * @prop {boolean} [isNotRequiredPassword=false] Whether the password is required or not.
 */
export const SuborderTakeModal = (props: {visible: any, onOk: any, onCancel: any, data: any, machine: any, isPackaging?: boolean, isNotRequiredPassword?: boolean}) => {
  const {visible, onOk, onCancel, data, machine, isPackaging} = props

  const onSave = (value: any) => {
    ApiRequest({
      url: 'Suborder/TakeSuborder?id=' + data.suborderId,
      method: 'put',
      data: {
        ...value,
        machineId: machine.machineId
      }
    }).then(_ => {
      onOk()
    })
  }

  return (
    <SuborderCommonModal
      visible={visible}
      onOk={onSave}
      onCancel={onCancel}
      data={data}
      machine={machine}
      isPackaging={isPackaging}
      isComplete={false}
      isNotRequiredPassword={props.isNotRequiredPassword}
    />
  )
}
